<template>
  <div class="index-wrap">
    index
  </div>

</template>

<script>
// import user from '@/api/user'
export default {
  name: 'index',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
	  // this.sta()
  },
  methods: {
	  sta(data){
	    user.loginStatus(data).then(res=>{
	      console.log(res)
	    })
	  }
  }
}
</script>
<style lang="scss" scoped>
  .index-wrap {

  }
</style>
